


const pubSub = {};

const subscribers = {};

pubSub.publish = function (event, data) {
    if (!subscribers[event]) return;
    subscribers[event].forEach(sub => sub(data));
};

pubSub.subscribe = function (event, callback) {
    if (!subscribers[event]) subscribers[event] = [];
    subscribers[event].push(callback);
};

pubSub.addToObject = function (obj) {
    if (obj.publish ||
        obj.subscribe ||
        obj.on ||
        obj.emit) {
        console.error(`Unable to add pub-sub to ${obj} - api overlaps with base-class`);
        return;
    }

    const subscribers = {};

    function on(event, callback) {
        if (!subscribers[event]) subscribers[event] = [];
        subscribers[event].push(callback);
    }

    function emit(event, data) {
        if (!subscribers[event]) return;
        subscribers[event].forEach(s => s(data, this));
    }

    Object.assign(obj, {
        on, emit,
        subscribe: on,
        publish: emit
    });
};



module.exports = pubSub;

